"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("../../../hooks");
var _Radio = _interopRequireDefault(require("../../../../Radio"));
var _usePrevious = _interopRequireDefault(require("../../../../../hooks/usePrevious"));
var _react = require("react");
var Styles = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var RadioGroup = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var allowDeselect = props.allowDeselect,
    children = props.children,
    disabled = props.disabled,
    name = props.name,
    options = props.options,
    readOnly = props.readOnly,
    containerProps = __rest(props, ["allowDeselect", "children", "disabled", "name", "options", "readOnly"]);
  var _a = (0, _hooks.useInputLogic)({
      defaultValue: "",
      disabled: disabled,
      name: name
    }),
    clearValidationMessages = _a.clearValidationMessages,
    disabledCombined = _a.disabled,
    getFieldValue = _a.getFieldValue,
    onBlur = _a.onBlur,
    setFieldValue = _a.setFieldValue,
    validateOnChange = _a.validateOnChange,
    value = _a.value;
  var previousValue = (0, _usePrevious.default)(value);
  var onChange = (0, _react.useCallback)(function (optionOnChange) {
    return function (event) {
      var value = String(getFieldValue(name)) === event.target.value && allowDeselect ? "" : event.target.value;
      setFieldValue(name, value);
      clearValidationMessages(name);
      validateOnChange(name, value);
      if (optionOnChange) {
        optionOnChange(event);
      }
    };
  }, [allowDeselect, clearValidationMessages, getFieldValue, name, setFieldValue, validateOnChange]);
  (0, _react.useEffect)(function () {
    if (previousValue !== value) {
      onBlur();
    }
  }, [onBlur, previousValue, value]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(Styles.Wrapper, __assign({
      ref: ref
    }, containerProps, {
      children: options.map(function (option) {
        return (0, _jsxRuntime.jsx)(_Radio.default, __assign({
          checked: String(value) === option.value
        }, option, {
          onClick: onChange(option.onClick),
          readOnly: option.readOnly || readOnly,
          disabled: option.disabled || disabledCombined
        }), option.value);
      })
    })), children]
  });
});
var _default = RadioGroup;
exports.default = _default;